import { hotKeywords } from "@/mocks/guaData";

// 上疏区：首屏大字标题 + 今日关键词（配图克制，纯排版）
export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      {/* 轻量背景装饰：极淡的墨色线条，保持干净轻壳 */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-full bg-[radial-gradient(circle_at_top_right,rgba(210,120,60,0.06),transparent_42%)]" />
      <div className="relative mx-auto flex max-w-7xl flex-col items-start px-4 pb-10 pt-14 md:px-6 md:pb-14 md:pt-20">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
          <i className="ri-flashlight-fill text-primary-500" />
          今日吃瓜现场
        </span>
        <h1 className="font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
          今天有什么瓜？
          <br />
          <span className="text-primary-600">先刷完这一单再说。</span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
          点开吃瓜m，先看今天有什么瓜，再翻最近瓜点get热瓜梗，最新瓜单实时滚动——刚爆的新鲜瓜，一条都别错过。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#live-feed"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill" />
            刷最新瓜单
          </a>
          <a
            href="#hot-rank"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition hover:border-primary-300 hover:text-primary-700"
          >
            看热瓜有哪些
          </a>
        </div>

        {/* 今日关键词 · 热梗 chips */}
        <div className="mt-12 w-full">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-foreground-400">
            今日关键词 · 热梗雷达
          </p>
          <div className="flex flex-wrap gap-2">
            {hotKeywords.map((kw) => (
              <a
                key={kw}
                href="#recent-point"
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                # {kw}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}